module.exports={
    "ASIA_LIVE_EVENT": "Asia Live Event",
    "ASIA_TV": "Asia BTV",
    "AUS_TV": "Australia BTV",
    "CURRENT_STREAM": "Current Stream",
    "CURRENT_STATION": "Current Station",
    "EMEA_LIVE_EVENT": "EMEA Live Event",
    "EUROPE_TV": "Europe BTV",
    "FOR_YOU": "For You",
    "GUESTS": "Guests",
    "LIVE_NOW": "LIVE NOW",
    "LIVE_ON_BLOOMBERG": "Live on Bloomberg TV",
    "LIVE_TV": "Live TV",
    "NOW_PLAYING": "NOW PLAYING",
    "POLITICS_LIVE_EVENT": "Politics Live Event",
    "WBBR_RADIO": "Bloomberg Radio",
    "STREAM_SCHEDULE": "Stream Schedule",
    "UP_NEXT": "UP NEXT",
    "US_LIVE_EVENT": "U.S. Live Event",
    "US_TV": "U.S. TV",
    "WATCH_NOW": "Watch Now",
    "404_DESCRIPTION": "Our apologies.<br/>We're unable to find the<br/>page you're looking for.",
    "404_BUTTON_TEXT": "Go To Our Home Page",
    "500_DESCRIPTION": "The server encountered an error and could not complete your request. If the problem persists, please report your problem and mention the error message.",
    "US_BTV": "U.S. BTV",
    "US_TV_PHOENIX": "U.S. BTV+",
    "SEE_FULL_SCHEDULE": "See Full Schedule",
    "NATIONAL_RADIO": "National",
    "BOSTON_RADIO": "Boston",
    "WASHINGTON_DC_RADIO": "Washington D.C.",
    "NEW_YORK_RADIO": "New York"
}
